import React from "react";
import { motion } from "framer-motion";
import { Spaced } from "@/components/site/Hero";
import { useT } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useT();
  return (
    <section id="about" className="relative py-24 lg:py-36 bg-white overflow-hidden">
      <img
        aria-hidden
        src="/hupla-emblem.svg"
        alt=""
        className="pointer-events-none select-none absolute -right-40 top-1/2 -translate-y-1/2 w-[720px] max-w-none opacity-[0.05]"
      />
      <div className="relative mx-auto max-w-[1200px] px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center font-display font-black text-[#001F39] text-[clamp(1.75rem,4vw,3.5rem)]"
        >
          <Spaced text={t("about.title")} />
        </motion.h2>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.15 }}
          className="mt-16 text-center text-xl md:text-2xl leading-[1.65] text-[#001F39] max-w-4xl mx-auto"
        >
          <span className="font-display font-black text-[#25bfcf]">Hupla</span>{" "}
          {t("about.body1")}
          <br />
          <br />
          {t("about.body2")}{" "}
          <span className="text-[#25bfcf] font-semibold">
            Mamm · Buzzer · Multimalt · Cafeo · Aperina ·
            White Elephant · Desser
          </span>{" "}
          {t("about.body3")}
        </motion.div>
      </div>
    </section>
  );
}

